"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("./constants.js");

var _locales = require("@stktk/locales");

var _commonUtils = require("./commonUtils.js");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Measurement = /*#__PURE__*/function () {
  function Measurement() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      amount: null,
      unit: null
    },
        amount = _ref.amount,
        unit = _ref.unit;

    _classCallCheck(this, Measurement);

    this.amount = amount;
    this.unit = unit;
  }
  /* FIXME: should it be here? */


  _createClass(Measurement, [{
    key: "localeDisplay",
    value: function localeDisplay() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        precision: null
      },
          precision = _ref2.precision;

      var amount = this.amount != null && Math.round(this.amount) !== this.amount ? this.amount.toFixed(precision) : this.amount;
      return amount != null ? amount + "".concat(this.unit ? ' ' + (0, _locales.__unit)(this.unit.id, _constants.UnitPropertyEnum.SHORT_NAME, this.amount) : '') : null;
    }
  }, {
    key: "multiply",
    value: function multiply(times) {
      if (times == null) this.amount = null;else this.amount = this.amount != null ? this.amount * times : this.amount;
      return this;
    }
  }, {
    key: "toBaseUnitMeasurement",
    value: function toBaseUnitMeasurement() {
      return new Measurement({
        amount: _constants.UnitEnum.typeNormalizedAmount(this.amount, this.unit),
        unit: _constants.UnitEnum.defaultTypeUnit(this.unit.type)
      });
    }
  }, {
    key: "compareTo",
    value: function compareTo(measurement) {
      var a = this.amount != null && this.unit ? this.amount : null;
      var b = measurement && measurement.amount != null && measurement.unit ? (0, _commonUtils.convertAmount)(measurement.amount, measurement.unit.id, this.unit ? this.unit.id : measurement.unit.id) : null;
      if (a == null && b == null) return 0;else if (a == null) return -1;else if (b == null) return 1;
      return a < b ? -1 : a == b ? 0 : 1;
    }
  }]);

  return Measurement;
}();

exports["default"] = Measurement;